<!-- <app-signup-modal-form></app-signup-modal-form> -->
<app-signup-no-password></app-signup-no-password>

<div class="footer-link">
  Have an account?
  <div (click)="openSignIn()" class="link font-medium">Sign in</div>
</div>
